type MockHostingType = {
  [key: number]: {
    name: string;
    notes?: string;
    capabilities?: {
      sites?: boolean;
      cpanel?: boolean;
      whm?: boolean;
      server_controls?: boolean;
      advanced_hosting?: boolean;
      reset_password?: boolean;
      hosting_upgrade?: boolean;
      cbs_backups?: boolean;
    };
  };
};

/** * hosting mappings */
const MOCK_HOSTING_ID_TO_TYPE: MockHostingType = {
  1000: {
    name: 'WP Basic',
    notes: '',
    capabilities: {
      sites: true,
      cpanel: true,
      whm: false,
      server_controls: false,
      advanced_hosting: false,
      reset_password: false,
      hosting_upgrade: true,
      cbs_backups: true,
    },
  },
  1100: { name: 'WP Choice Plus' },
  1200: { name: 'WP Plus' },
  1300: { name: 'WP Pro' },
  1310: { name: 'Online Store' },
  1320: { name: 'Online Store + Marketplace' },
  2000: {
    name: 'VPS Standard',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
      hosting_upgrade: false,
    },
  },
  2100: {
    name: 'VPS Enhanced',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
      hosting_upgrade: false,
    },
  },
  2200: {
    name: 'VPS Ultimate',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
      hosting_upgrade: false,
    },
  },
  3000: {
    name: 'Dedicated Standard',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
    },
  },
  3100: {
    name: 'Dedicated Enhanced',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
    },
  },
  3200: {
    name: 'Dedicated Premium',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
      hosting_upgrade: false,
    },
  },
  4000: {
    name: 'Reseller',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: true,
      server_controls: false,
      whm: false,
      advanced_hosting: false,
      hosting_upgrade: true,
      reset_password: false,
    },
  },
  9000: {
    name: 'VPS Standard',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
      hosting_upgrade: false,
    },
  },
  10000: {
    name: 'Dedicated Standard',
    notes: '',
    capabilities: {
      sites: false,
      cpanel: false,
      whm: true,
      server_controls: true,
      advanced_hosting: true,
      hosting_upgrade: false,
    },
  },
};
export default MOCK_HOSTING_ID_TO_TYPE;
